import React from 'react';
import Modal from 'react-modal';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import s from './LoadingScreenModal.scss';

export interface Props {}

const LoadingScreenModal: React.FC<Props> = props => {
  return (
    <Modal isOpen className="override" overlayClassName={s['reload-overlay']}>
      <LoadingIndicator coverMode withOverlay={true} view="daSymbol" />
    </Modal>
  );
};
LoadingScreenModal.displayName = 'LoadingScreenModal';

export default LoadingScreenModal;
